import React, { useEffect, useMemo } from 'react';

// DEPENDENCIES
import format from 'date-fns/format';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import lastDayOfMonth from 'date-fns/lastDayOfMonth';
import { useFormikContext } from 'formik';

// GLOBAL VARIABLES
import { DATE_FORMATS } from 'globals.js';

// HOOKS
import { useRecordContext } from 'helpers/getRecordData';

// CORE COMPONENTS
import Form from 'core/form/Form';

// FUNCTIONS
const getMonthYear = d => format(new Date(d), 'MMMM, yyyy');

// MAIN COMPONENT
const FalloutCurrentMonth = props => {

  // FORMIK
  const { values: { fallout_in_current_month }, setFieldValue } = useFormikContext();

  // HOOKS
  const { record: { sales_time } } = useRecordContext();

  // MEMOS
  const currentMonthYear = getMonthYear(new Date());
  const isSalesCurrentMonth = currentMonthYear === getMonthYear(new Date(sales_time));
  const [
    minDate,
    maxDate
  ] = useMemo(
    () => {
      switch (fallout_in_current_month) {
        case '0':
          return [
            new Date(sales_time),
            endOfMonth(new Date(sales_time))
          ];
        case '1':
          return [
            startOfMonth(new Date()),
            new Date()
          ];
        default:
          return [];
      };
    },
    [fallout_in_current_month, sales_time]
  );

  // EFFECTS
  useEffect(
    () => {
      switch (fallout_in_current_month) {
        case '0':
          setFieldValue('fallout_date', format(lastDayOfMonth(new Date(sales_time)), DATE_FORMATS.date));
          return;
        case '1':
          setFieldValue('fallout_date', format(new Date(), DATE_FORMATS.date));
          return;
        default:
          return;
      }
    },
    [fallout_in_current_month, sales_time, setFieldValue]
  )

  return !isSalesCurrentMonth && sales_time ? (<>
    <Form.Col>
      <big><span className="text-danger">Alert:</span> You are trying to fallout a deal from a previous month.</big>
    </Form.Col>
    <Form.YesNo
      name="fallout_in_current_month"
      label={`Will this fallout be counted in ${currentMonthYear}?`}
      numeric
      required
      {...props}
    />
    <Form.Date
      name="fallout_date"
      label="Fallout Date"
      minDate={minDate}
      maxDate={maxDate}
      vertical
      required
      {...props}
      disabled={!fallout_in_current_month}
    />
  </>) : null;
}

// EXPORT
export default FalloutCurrentMonth;
